import { useMutation } from '@tanstack/react-query';
import { deleteAttachment } from '../Services/ProcessedTimesheetService';

const useDeleteProcessedTimesheetAttachment = (options = {}) =>
    useMutation(deleteAttachment, options);

export default useDeleteProcessedTimesheetAttachment;
